<div class="breadcrumb-area">
	<h1>Cuentas por Cobrar</h1>
</div>
<div class="card mb-2" id="receivable-data">
	<div class="card-body">
		<div class="form-group">
			<label for="client-input" class="form-label">Cliente</label>
			<div class="input-group input-group-sm" style="margin-bottom: 1em;">
				<app-input-autocomplete [ruleToDisabled]="clients.length == 0" [allBorderRadius]="true"
					[inputs]="client" [placeholder]="'Ingresa el nit o el nombre de un cliente'"
					[filterElements]="client.filterElements" [typeElements]="'client'" (inputMethod)="writeClient()"
					(changeStatus)="selectClient($event.filterElement,1)" [custom]="true">
					<ng-template #itemsTemplate let-filter>
						<!-- This is the content that will be projected -->
						<div items>
							<h5 class="text-info" style="line-height: normal; margin-bottom: 0;">
								{{filter.name}}</h5>
							<span style="color: white;">NIT: <b>{{filter.nit}}</b></span>
						</div>
					</ng-template>
				</app-input-autocomplete>
			</div>
		</div>
		<div *ngIf="accounts.length == 0">
			<div class="row" style="color: var(--bs-bg-servicios)">
				<div class="col-sm-10">
					<span class="display-4"> Ingresa los clientes que saldaran sus cuentas
					</span>
				</div>
				<div class="col-sm-2" style="display: flex; flex-direction: row; justify-content: center;">
					<span class="display-2"
						style="display: flex; justify-content: center; flex-direction: row; align-items: center;">
						<i class="fa fa-hand-pointer bouncing-hand"></i>
					</span>
				</div>
			</div>
		</div>
		<div class="mb-3" *ngIf="accounts.length > 0">
			<table class="table table-bordered">
				<thead>
					<tr class="tr-middle tr-no-border-top">
						<th class="limit-td limit-td-75">Datos del cliente</th>
						<th>Imagen</th>
						<th>Tipo de cobro</th>
						<th>Cantidad</th>
						<th style="border: none !important;"></th>
					</tr>
				</thead>
				<tbody>
					<tr class="tr-middle" *ngFor="let account of accounts; let i = index">
						<td class="limit-td limit-td-100" style="min-width: 100px !important;">
							<p style="font-weight: bold; font-size: 1.1em;">{{account.client.nit}}</p>
							<p style="font-weight: lighter; font-size: 0.8em;">{{account.client.name}}</p>
						</td>
						<td class="limit-td limit-td-50">
							<span class="span-button" [class.opacity-20]="!account.logo" (click)="selectImage(i)">
								<img id="image{{i}}"
									src="{{account.logo?account.logo:'../../../../../assets/img/nophoto.svg'}}"
									alt="Sin foto" class="no-photo" width="auto" height="50%"
									(error)="$event.target.src = '../../../../../assets/img/nophoto.svg'">
								<div class="container-image-control">
									<i [ngClass]="account.logo?'fa fa-edit':'fa fa-plus'"></i>
								</div>
								<input type="file" (change)="changeFile($event, i, account)" accept="image/*"
									class="file-hide" name="file{{i}}" id="file{{i}}">
							</span>
						</td>
						<td>
							<div class="input-group">
								<select id="typePayment" name="typePayment" (change)="changeTypePayment(i)"
									[(ngModel)]="account.typePayment" class="form-select">
									<option [ngValue]="null">Selecciona un tipo de pago</option>
									<option [ngValue]="0">Efectivo</option>
									<option [ngValue]="1">Cheque</option>
									<option [ngValue]="3">Transferencia</option>
								</select>
								<button class="btn btn-info"
									(click)="showDataPayment[account.clientId] = !showDataPayment[account.clientId]">
									<i class="fa"
										[tooltip]="showDataPayment[account.clientId]?'Ocultar datos':'Mostrar datos'"
										[ngClass]="showDataPayment[account.clientId]?'fa-eye-slash':'fa-eye'"></i>
									<i *ngIf="!account.isComplete()" class="fa fa-asterisk text-danger"></i>
								</button>
							</div>
							<div *ngIf="showDataPayment[account.clientId]">
								<div class="mt-3" [hidden]="account.typePayment!=1" id="check">
									<h5>Datos del cheque <i *ngIf="!account.isComplete()"
											class="fa fa-asterisk text-danger"></i></h5>
									<div class="input-group">
										<label for="bankCheck" class="input-group-text">Banco Emisor</label>
										<select name="bankCheck" (change)="updateClientList()"
											[(ngModel)]="account.bankCheck" id="bankCheck" class="form-select">
											<option value="undefined">Selecciona un banco</option>
											<option *ngFor="let bank of banks" value="{{bank.id}}">{{bank.name}}
											</option>
										</select>
									</div>
									<div class="input-group">
										<label for="dateCheck" class="input-group-text">Fecha</label>
										<input type="date" (change)="updateClientList()" name="dateCheck"
											[(ngModel)]="account.dateCheck" id="dateCheck" class="form-control">
									</div>
									<div class="input-group">
										<label for="numberCheck" class="input-group-text"># Cheque</label>
										<input type="number" (change)="updateClientList()" name="numberCheck"
											id="numberCheck" placeholder="Número de cheque"
											[(ngModel)]="account.numberCheck" class="form-control">
									</div><!-- 
									<div class="input-group">
										<label for="numberAccount" class="input-group-text"># Cuenta</label>
										<input type="number" (change)="updateClientList()" name="numberAccount"
											id="numberAccount" placeholder="Número de cuenta"
											[(ngModel)]="account.numberAccountCheck" class="form-control">
									</div> -->
								</div>

								<h5 [hidden]="account.typePayment !== 0">Datos del efectivo <i
										*ngIf="!account.isComplete()" class="fa fa-asterisk text-danger"></i></h5>
								<div class="input-group" [hidden]="account.typePayment == 3">
									<label for="mount-cash" class="input-group-text">Caja</label>
									<app-input-autocomplete [allBorderRadius]="true" [inputs]="account.cash"
										[placeholder]="'Ingresa o selecciona una caja'"
										[filterElements]="account.cash.filterElements" [typeElements]="'cashier'"
										(inputMethod)="writeCashier(account)"
										(getTitle)="$event.filterElement.title = $event.filterElement.name"
										(changeStatus)="selectCashier($event.filterElement, account)"></app-input-autocomplete>
									<!-- <div class="autocomplete" id="cashier-select"
											style="background: white !important; border-radius: var(--bs-border-radius);">
											<input type="text"
												style="border-radius: var(--bs-border-radius) !important;"
												[class.required]="!inputs.cashier.verified"
												class="form-control input-suggestions" name="cashier" id="cashier"
												[(ngModel)]="inputs.cashier.value"
												placeholder="Ingresa o selecciona una caja"
												(input)="handleInput($event,'cashier')" (click)="focusCashier = true"
												(change)="verifiedInput($event,'cashier')" autocomplete="off">
											<div class="suggestions" id="suggestionsCashier" *ngIf="focusCashier">
												<ng-container *ngFor="let filter of filterCashiers">
													<div class="suggestions-item"
														(click)="changeStatusInput(filter, filter.name, 1, 'cashier')">
														{{filter.name}}</div>
												</ng-container>
											</div>
											<span class="input-status">
												<i data-bs-toggle="tooltip" id="status-cashier" data-bs-placement="top"
													data-bs-custom-class="custom-tooltip"
													[attr.data-bs-title]="inputs.cashier.message"
													[attr.data-original-title]="inputs.cashier.message"
													class="fa {{inputs.cashier.class}}"></i>
											</span>
										</div> -->
								</div>
								<div class="mt-3" [hidden]="account.typePayment!=2" id="card">
									<h5>Datos de la tarjeta <i *ngIf="!account.isComplete()"
											class="fa fa-asterisk text-danger"></i></h5>
									<div class="input-group">
										<label for="typeCard" class="input-group-text">Tipo de Tarjeta</label>
										<select name="typeCard" (change)="updateClientList()" id="typeCard"
											[(ngModel)]="account.typeCard" class="form-select">
											<option value="undefined">Selecciona un tipo de tarjeta</option>
											<option *ngFor="let typeCard of typeCards" value="{{typeCard.id}}">
												{{typeCard.name}}</option>
										</select>
									</div>
									<div class="input-group">
										<label for="referenceCard" class="input-group-text">Referencia</label>
										<input type="text" (change)="updateClientList()" name="referenceCard"
											[(ngModel)]="account.referenceCard" id="referenceCard"
											placeholder="Ingresa una referencia" class="form-control">
									</div>
									<div class="input-group">
										<label for="authorizationCard" class="input-group-text">Autorización</label>
										<input type="text" (change)="updateClientList()" name="authorizationCard"
											id="authorizationCard" placeholder="Ingresa la autorización"
											[(ngModel)]="account.authorizationCard" class="form-control">
									</div>
								</div>
								<div class="mt-3" [hidden]="account.typePayment!=3" id="card">
									<h5>Datos de la transferencia <i *ngIf="!account.isComplete()"
											class="fa fa-asterisk text-danger"></i></h5>
									<div class="input-group">
										<label for="accountIdTransfer" class="input-group-text">Cuenta Bancaria</label>
										<select name="accountIdTransfer" (change)="updateClientList()"
											id="accountIdTransfer" [(ngModel)]="account.accountIdTransfer"
											class="form-select">
											<option value="undefined">Selecciona una cuenta activa</option>
											<option *ngFor="let bankAccount of bankAccounts" value="{{bankAccount.id}}">
												{{bankAccount.accountNumber}} - {{bankAccount.alias}}</option>
										</select>
									</div>
									<div class="input-group">
										<label for="numberTransfer" class="input-group-text">Número</label>
										<input type="number" (change)="updateClientList()" name="numberTransfer"
											[(ngModel)]="account.numberTransfer" id="numberTransfer"
											placeholder="Ingresa el número de transferencia" class="form-control">
									</div><!-- 
									<div class="input-group">
										<label for="amountAdvanceTransfer" class="input-group-text">Cantidad
											Anticipo</label>
										<input type="number" (change)="updateClientList()" name="amountAdvanceTransfer"
											id="amountAdvanceTransfer" placeholder="Ingresa el anticipo"
											[(ngModel)]="account.amountAdvanceTransfer" class="form-control">
									</div> -->
								</div>
							</div>
						</td>
						<td>
							<div class="input-group">
								<label for="amount" class="input-group-text">Q. </label>
								<input [class.bg-danger-custom]="!account.amount" type="number"
									(change)="updateClientList()" id="amount" placeholder="Cantidad" name="amount"
									[(ngModel)]="account.amount" class="form-control">
							</div>
							<div class="form-group mt-3">
								<label for="reference" style="text-align: left !important;"
									class="form-label">Referencia</label>
								<input [class.bg-danger-custom]="!account.reference" [(ngModel)]="account.reference"
									type="text" (change)="updateClientList()" placeholder="Ingresa una referencia"
									id="reference" name="reference" class="form-control">
							</div>
							<div class="form-group">
								<label for="date" class="form-label">Fecha</label>
								<input [class.bg-danger-custom]="!account.date" [(ngModel)]="account.date" type="date"
									(change)="updateClientList()" id="date" name="date" class="form-control">
							</div>
						</td>
						<td>
							<span class="clickeable text-danger" (click)="deleteClientOfList(i)">
								<i class="fa fa-trash"></i>
							</span>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<app-loading-button *ngIf="accounts.length > 0" [logo]="true" [colorLoading]="'white'" style="width: 100%;"
			[object]="buttonSave" (clicked)="saveAccountReceivable()"></app-loading-button>
	</div>
</div>